export const ERROR_MESSAGES = {
  GENERIC_CHAT_ERROR: "I’m sorry, I can’t give an answer to that.",
  INPUT_QUERY_TOO_LONG: "Question too long. Shorten it so we can give a clearer answer.",
} as const;
